export enum Custodian {
  Fidelity = 'cust_fidelity',
  Schwab = 'cust_schwab',
  Pershing = 'cust_pershing',
  RBC = 'cust_rbc',
  LPL = 'cust_lpl',
  Goldman = 'cust_goldman',
  Vision = 'cust_vision',
}
